import { styled } from '@acko-tech/building-blocks.ui.common';

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    padding: 20px;
    max-width: 400px;
    margin: 0 auto;
    @media screen and (max-width: 769px) {
        max-width: 700px;
        margin: 0;
    }
`;

export const BackArrowIcon = styled.div`
    display: flex;
    cursor: pointer;
`;

export const Title = styled.div`
    display: flex;
    font-weight: 600;
    font-size: 20px;
    line-height: 24px;
    color: #040222;
    margin-top: 10px;
`;

export const SubTitle = styled.div`
    margin-top: 12px;
    font-size: 14px;
    line-height: 24px;
    color: #666666;
    font-weight: 400;
`;

export const AmountCard = styled.div`
    margin-top: 36px;
    padding: 15px;
    border-radius: 12px;
    background: rgba(82, 82, 86, 0.08);
    border: 1px solid #e3e4f2;
    box-shadow: 0 2px 10px rgba(4, 2, 34, 0.08);
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

export const AmountLabel = styled.div`
    font-size: 14px;
    line-height: 24px;
    color: #666666;
`;

export const AmountValue = styled.div`
    font-size: 20px;
    line-height: 24px;
    font-weight: 600;
    color: #040222;
`;

export const OptionCard = styled.div<{
    isSelected: boolean;
    isDisabled: boolean;
}>`
    margin-top: 20px;
    padding: 14px;
    border-radius: 12px;
    border: ${({ isSelected, isDisabled }) =>
        isSelected
            ? '2px solid #2463eb'
            : isDisabled
            ? '1px solid rgba(218, 218, 250, 0.24)'
            : '1px solid rgba(98, 99, 187, 0.08)'};
    background: ${({ isDisabled }) =>
        isDisabled ? 'rgba(126, 126, 129, 0.08)' : '#2463eb0d'};
    box-shadow: 0 2px 10px rgba(4, 2, 34, 0.08);
    cursor: ${({ isDisabled }) => (isDisabled ? 'not-allowed' : 'pointer')};
    opacity: ${({ isDisabled }) => (isDisabled ? 0.4 : 1)};
`;

export const OptionTopRow = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
`;

export const Radio = styled.div<{ isSelected: boolean }>`
    width: 18px;
    height: 18px;
    border-radius: 50%;
    border: 1px solid #2563eb;
    position: relative;
    flex-shrink: 0;

    &::after {
        content: '';
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background: #2563eb;
        position: absolute;
        top: 3px;
        left: 3px;
        opacity: ${({ isSelected }) => (isSelected ? 1 : 0)};
    }
`;

export const IconWrapper = styled.div`
    margin: 5px;
    color: #2563eb;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const OptionTitle = styled.div`
    font-size: 14px;
    line-height: 24px;
    font-weight: 600;
    color: #040222;
`;

export const OptionSuccessText = styled.div`
    margin-top: 4px;
    margin-left: 24px;
    font-size: 14px;
    line-height: 24px;
    font-weight: 200;
    color: #666666;
`;

export const StickyFooter = styled.div`
    margin-top: auto;
    padding-top: 25px;
    padding-bottom: 10px;
`;

export const WarningTitleContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: left;
    margin-left: 10px;
`;

export const WarningTitleText = styled.div`
    color: rgba(229, 14, 14, 0.8);
    font-weight: 400;
    font-size: 14px;
    margin-left: 6px;
`;

export const RedirectInfoCard = styled.div`
    margin-top: 10px;
    padding: 12px 15px;
    border-radius: 12px;
    border: 1px solid rgba(37, 99, 235, 0.2);
    background: rgba(37, 99, 235, 0.08);
`;

export const RedirectInfoTitle = styled.div`
    font-size: 14px;
    line-height: 20px;
    font-weight: 400;
    color: #2563eb;
`;

export const RedirectInfoSubText = styled.div`
    margin-top: 4px;
    margin-left: 44px;
    font-size: 12px;
    line-height: 20px;
    color: rgba(37, 99, 235, 0.9);
`;
